export default __webpack_public_path__ + "static/media/videocam.12890edd.svg";